import React from 'react';
import classes from "./ErrorMessage.module.css";
import ErrorMessageContext from '../../store/ErrorMessageContext';
import { useContext } from "react"

const ErrorMessage = () => {
    const { errorMessages, showErrorMessage, clearErrorMessages } = useContext(ErrorMessageContext);

  const handleCloseErrorMessage = () => {
    clearErrorMessages();
  };

  if (!showErrorMessage) {
    return null;
  }

  return (
    <div className={classes.errorMessageContainer}>
      <div className={classes.errorMessage}>
        {[...errorMessages].map((message, index) => (
          <p key={index}>{message}</p>
        ))}
      </div>
      <button onClick={handleCloseErrorMessage} className={classes.closeButton}>X</button>
    </div>
  );
}

export default ErrorMessage;
